import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.dom-exception.stack.js";
import axios from 'axios';
import AccountService from '@/services/AccountService';
import UserService from '@/services/UserService';
import VueRecaptcha from '@/components/widget/VueRecaptcha';
import Loading from '@/components/widget/Loading';
import AddressForm from '@/components/forms/Address';
import BillingForm from '@/components/billing/Form';
import DiscountCode from '@/components/billing/DiscountCode';
import { validationMixin, useSpinValidate } from '@/plugins/vuelidateCompat';
import { required, email, minLength, sameAs, helpers } from '@vuelidate/validators';
const cellPhone = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true;
  } else {
    return /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/.test(value);
  }
};
export default {
  components: {
    Loading,
    AddressForm,
    BillingForm,
    DiscountCode,
    VueRecaptcha
  },
  data: () => {
    return {
      loading: false,
      searchUsername: false,
      searchEmail: false,
      usernameTaken: false,
      emailTaken: false,
      checkEmailTimer: null,
      checkUsernameTimer: null,
      billingName: null,
      account: {
        subscriptiontype_id: null,
        captcha_response: null,
        user: {
          firstname: null,
          lastname: null,
          email: null,
          username: null,
          password: null,
          password2: null,
          phone: null,
          countrycode_id: null,
          terms: false,
          privacy: false,
          promo: true
        },
        address: {
          address1: null,
          address2: null,
          city: null,
          state: null,
          state_id: null,
          zip: null,
          country_id: '184',
          valid: false
        },
        billing: {
          billingtype_id: 1,
          creditcardtype: null,
          name: null,
          firstname: null,
          lastname: null,
          number: null,
          expmonth: null,
          expyear: null,
          cvc: null,
          valid: false
        },
        billingAddressSame: true,
        billingAddress: {
          address1: null,
          address2: null,
          city: null,
          state_id: null,
          zip: null,
          country_id: '184',
          valid: false
        },
        discount: {}
      },
      states: [],
      countries: [],
      subscriptiontypes: [],
      subscriptiontype: null,
      captcharesponse: false
    };
  },
  props: {
    subtype: {
      type: [Number, String],
      default: null
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      AccountService.createInit(this.subtype).then(response => {
        this.states = response.data.states;
        this.countries = response.data.countries;
        this.subscriptiontypes = response.data.subscriptiontypes;
        if (this.subscriptiontypes.length === 1) {
          this.selectSubType(this.subscriptiontypes[0]);
        } else if (this.subtype && +this.subtype > 0) {
          let st = null;
          this.subscriptiontypes.some(t => {
            if (t.id === this.subtype) {
              st = t;
              return true;
            }
            return false;
          });
          if (st) {
            this.selectSubType(st);
          }
        }
      }).catch(error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
        this.$v.account.$touch();
      });
    },
    handleSuccess(response) {
      this.account.captcha_response = response;
      this.captcharesponse = true;
    },
    handleError(response) {},
    selectSubType(type) {
      this.account.subscriptiontype_id = type.id;
      this.subscriptiontype = type;
    },
    clearSubscriptionType() {
      this.account.subscriptiontype_id = null;
      this.account.discount = {};
      this.subscriptiontype = null;
    },
    getErrors(form, field, validators) {
      const err = [];
      if (!this.$v.account[form][field].$dirty) return err;
      validators.forEach(e => {
        if (this.$v.account[form][field][e].$invalid) {
          e === 'sameAsPassword' && err.push('Passwords do not match');
          e === 'minLength' && err.push(field.capitalize() + ' must be at least ' + this.$v.account[form][field].minLength.$params.min + ' characters');
          e === 'email' && err.push('Please enter a valid email');
          e === 'cellPhone' && err.push('Please enter a valid phone number');
        }
      });
      return err;
    },
    setBilling(info) {
      if (!info || !info.billing) {
        return false;
      }
      if (info.billing.name && info.billing.name.length > 0) {
        this.account.billing.name = info.billing.name;
      }
      if (!info.billing.billingAddressSame) {
        this.account.billingAddress = info.billingAddress;
      }
      if (info.billing.number) {
        this.account.billing.number = info.billing.number;
      }
      if (info.billing.expmonth) {
        this.account.billing.expmonth = info.billing.expmonth;
      }
      if (info.billing.expyear) {
        this.account.billing.expyear = info.billing.expyear;
      }
      if (info.billing.cvc) {
        this.account.billing.cvc = info.billing.cvc;
      }
      if (info.billing.creditcardtype) {
        this.account.billing.creditcardtype = info.billing.creditcardtype;
      }
      this.account.billing.valid = info.billing.valid;
    },
    /** populate billing name on user first/last input */
    setBillingName() {
      this.billingName = '';
      if (this.account.user.firstname) {
        this.billingName = this.account.user.firstname;
      }
      if (this.account.user.lastname) {
        this.billingName += ' ' + this.account.user.lastname;
      }
    },
    setUserAddress(address) {
      this.account.address = address;
    },
    prepData() {
      const data = JSON.parse(JSON.stringify(this.account));
      data.amount = this.subscriptiontype.amount;
      data.role_id = this.subscriptiontype.role_id;
      if (data.billingAddressSame) {
        data.billingAddress = data.address;
      }
      delete data.billingAddressSame;
      if (data.billing.name) {
        const n = data.billing.name.split(' ');
        data.billing.lastname = n.pop();
        data.billing.firstname = n.join(' ');
        delete data.billing.name;
      }
      if (data.billing.number) {
        data.billing.number = btoa(data.billing.number);
        data.billing.cvc = btoa(data.billing.cvc);
      }
      return data;
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid || this.amountDue > 0 && !this.account.billing.valid) {
        let messages = '';
        if (this.account.subscriptiontype_id === null) {
          messages += '<p style="color: red">No subscription type selected.</p>';
        }
        if (this.$v.$invalid) {
          messages += '<p style="color: red">Missing or invalid data. Look for any sections of the form highlighted in red.</p>';
        }
        if (this.amountDue > 0 && !this.account.billing.valid) {
          messages += '<p style="color: red">Billing information is invalid</p>';
        }
        // Vue 3 dropped this.$createElement; pass HTML as string and let the
        // $bvModal compat shim render it. messages is already HTML.
        this.$bvModal.msgBoxOk(messages, {
          title: 'Errors found'
        });
        return false;
      }
      const data = this.prepData();
      this.loading = true;
      AccountService.create(data).then(response => {
        axios.defaults.headers.common.Authorization = 'Bearer ' + response.data.apikey;
        UserService.refresh().then(refresh => {
          UserService.setStorage(refresh.data);
          // response.data.redirect = '/'
          this.$aim.notify(response);
          // hard reload
          window.location.href = '/';
        }).catch(error => {
          this.$aim.error(error.response);
          this.loading = false;
        });
      }).catch(error => {
        this.$aim.error(error.response);
        this.loading = false;
      });
    },
    /**
     * Set the discount this user is using, from the
     * discououtcode.vue event
     */
    applyDiscount(discount) {
      this.account.discount = discount;
    }
  },
  computed: {
    /**
     * @returns {Array}
     */
    countryCodes: function () {
      const codes = [];
      this.countries.forEach(e => {
        codes.push({
          value: e.id,
          text: e.isothreeletter + ' - +' + e.countrycode
        });
      });
      return codes;
    },
    /**
     * @returns {Number}
     */
    amountDue() {
      return this.account && this.account.discount && this.account.discount.id > 0 ? parseFloat(this.account.discount.subscriptiontype.amount) : this.subscriptiontype ? parseFloat(this.subscriptiontype.amount) : 0;
    },
    /**
     * @returns {String}
     */
    amountDueFormatted() {
      return this.account.discount && this.account.discount.id > 0 ? this.account.discount.subscriptiontype.localcurrencyformatted : this.subscriptiontype ? this.subscriptiontype.localcurrencyformatted : 0;
    }
  },
  filters: {
    /**
     * @returns {String}
     */
    billingType: function (val) {
      return val > 1 ? 'Billed Annually Until Cancellation' : val ? 'Billed Monthly Until Cancellation' : 'One Time Payment';
    }
  },
  mixins: [validationMixin],
  setup() {
    return useSpinValidate();
  },
  validations: {
    account: {
      captcha_response: {
        required
      },
      user: {
        username: {
          required,
          minLength: minLength(5),
          // Vuelidate 2 treats an unwrapped Promise as valid; withAsync makes it wait for the API
          isUnique: helpers.withAsync(function (value) {
            return new Promise(resolve => {
              if (this.checkUsernameTimer) {
                clearTimeout(this.checkUsernameTimer);
                this.checkUsernameTimer = null;
              }
              if (!value || value.length < 5) {
                resolve(false);
              } else {
                this.checkUsernameTimer = setTimeout(() => {
                  this.searchUsername = true;
                  AccountService.checkUsername(value).then(response => {
                    if (response.data && response.data.exists !== undefined) {
                      this.searchUsername = false;
                      resolve(response.data.exists);
                    } else {
                      this.searchUsername = false;
                      resolve(false);
                    }
                  }).catch(() => resolve(false));
                }, 700);
              }
            });
          })
        },
        password: {
          required,
          minLength: minLength(6)
        },
        password2: {
          required,
          // Vuelidate 2 sameAs() compares to a value, not a field name
          sameAsPassword: (value, siblings) => value === siblings.password
        },
        firstname: {
          required
        },
        lastname: {
          required
        },
        email: {
          required,
          email,
          isUnique: helpers.withAsync(function (value) {
            return new Promise(resolve => {
              if (this.checkEmailTimer) {
                clearTimeout(this.checkEmailTimer);
                this.checkEmailTimer = null;
              }
              if (!value) {
                resolve(false);
              } else if (!email.$validator(value)) {
                // Vuelidate 2 validators are objects, not functions
                resolve(false);
              } else {
                this.checkEmailTimer = setTimeout(() => {
                  this.searchEmail = true;
                  AccountService.checkEmail(value).then(response => {
                    if (response.data && response.data.exists !== undefined) {
                      this.searchEmail = false;
                      resolve(response.data.exists);
                    } else {
                      this.searchEmail = false;
                      resolve(false);
                    }
                  }).catch(() => resolve(false));
                }, 700);
              }
            });
          })
        },
        phone: {
          required,
          minLength: minLength(10),
          cellPhone
        },
        countrycode_id: {
          required
        },
        terms: {
          required,
          checked: sameAs(true)
        },
        privacy: {
          required,
          checked: sameAs(true)
        }
      },
      address: {
        address1: {
          required
        },
        zip: {
          required,
          minLength: minLength(5)
        },
        city: {
          required
        },
        state: {
          required
        },
        country_id: {
          required
        }
      }
    }
  }
};